<template>
  <uni-popup ref="drugLeaflet" type="bottom" @close="close" @maskClick="close">
    <uni-card title="药品说明书" :is-full="true" :note="true">
      <scroll-view scroll-y="true" class="leaflet-scroll">
        <div v-if="leafletDataObj.length === 0 && pics.length === 0" class="no-content">
          <img
            src="@funcPuzzle/mini_patient/default/no-content.png"
            class="no-content-img"
          />
          <span class="text">暂无药品说明书</span>
        </div>
        <div v-else>
          <div v-for="item in leafletDataObj" :key="item" class="leaflet-item">
            <span class="label">{{ item.label }}</span>
            <span class="desc">{{ item.value }}</span>
          </div>
          <div v-if="pics.length > 0" class="img-view">
            <img
              v-for="imgitem in pics"
              :key="imgitem"
              :src="imgitem"
              class="leaflet-imgitem"
              mode="widthFix"
            />
          </div>
        </div>
      </scroll-view>
      <template v-slot:close>
        <uni-icons type="closeempty" color="#666" @click="close" />
      </template>
      <template v-slot:footer>
        <div class="footer-box" @click="close">
          <span class="btn">上一步</span>
        </div>
      </template>
    </uni-card>
  </uni-popup>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {
  selectDrugManual // 查询药品说明书数据
} from '@/views/funcPuzzle/utils/index.js'
import { outImageFullPath } from '@/views/funcPuzzle/utils/util.js'
export default {
  data() {
    return {
      leafletKeys: {
        productName: { label: '商品名称', value: '' },
        commonName: { label: '通用名称', value: '' },
        englishName: { label: '英文名称', value: '' },
        pinyinCode: { label: '汉语拼音', value: '' },
        actionType: { label: '作用类型', value: '' },
        drugType: { label: '药品类型', value: '' },
        drugSpec: { label: '规格', value: '' },
        mainIngredient: { label: '主要成分', value: '' },
        traits: { label: '性状', value: '' },
        indicationsFunction: { label: '功能主治', value: '' },
        dosage: { label: '用法用量', value: '' },
        permitNo: { label: '批准文号', value: '' },
        manufacturer: { label: '生产企业', value: '' },
        adverseReactions: { label: '不良反应', value: '' },
        eschew: { label: '禁忌', value: '' },
        precautions: { label: '注意事项', value: '' },
        forPeople: { label: '适用人群', value: '' },
        pregnantMedication: { label: '孕妇及哺乳期妇女用药', value: '' },
        childMedication: { label: '儿童用药', value: '' },
        geriatricMedication: { label: '老人用药', value: '' },
        medicineInteractions: { label: '药物相互作用', value: '' },
        pharmacologyAndToxicology: { label: '药理毒理', value: '' },
        pharmacokinetics: { label: '药代动力学', value: '' },
        drugStorage: { label: '储藏', value: '' },
        packagingUnit: { label: '包装单位', value: '' },
        validityPeriod: { label: '有效期', value: '' },
        marketingAuthorization: { label: '上市许可证持有人', value: '' }
        // uploadPicture: { label: '图片', value: '' }
      },
      pics: [],
      leafletDataObj: []
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    ...mapGetters(['leafletData'])
  },
  methods: {
    open(opts = {}) {
      // this.setDrugDesc('1')
      // this.formatLeafletData(opts)
      // this.$emit('update:visible', true)
      // this.$refs.drugLeaflet.open()
      this.fetchLeafletData()
    },
    close() {
      this.leafletDataObj = []
      this.pics = []
      this.$refs.drugLeaflet.close()
      this.$store.dispatch('setLeafletStatus', false)
      this.$store.dispatch('setLeafletData', {})
    },
    formatLeafletData(list = {}) {
      for (const key of Object.keys(list)) {
        if (this.leafletKeys[key]) {
          if (list[key]) {
            this.leafletKeys[key].value = list[key]
            this.leafletDataObj.push(this.leafletKeys[key])
          }
        }
      }

      const _pics = (list.uploadPicture || '')
        .split(',')
        .filter(item => item)
        .map(item => {
          return outImageFullPath(item)
        })
      this.pics = _pics
    },
    // 获取说明书数据
    async fetchLeafletData() {
      try {
        const params = {
          // baseDrugId: this.baseDrugId,
          hospitalID: this.userInfos.hospitalID,
          drugID: this.leafletData.drugID
          // commonName: item.drugName
        }
        const res = await selectDrugManual(params)
        if (res.code === 0) {
          this.formatLeafletData(res.TBaseDrugManual || {})
          this.$refs.drugLeaflet.open()
          // this.$refs.drugLeafletModal.open(res.TBaseDrugManual || {})
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.no-content {
  width: 100%;
  box-sizing: border-box;
  padding-top: 5.333333rem;
  text-align: center;

  .no-content-img {
    display: inline-block;
    width: 6.826667rem;
    height: 6.826667rem;
  }
  .text {
    display: block;
    padding: 0.64rem 0;
    font-size: 0.64rem;
    color: #888;
  }
}
.leaflet-scroll {
  height: calc(100vh - 6.613333rem);
  padding: 0.682667rem 0 0;
  box-sizing: border-box;
}
.leaflet-item + .leaflet-item {
  margin-top: 0.853333rem;
}
.leaflet-item {
  display: flex;
  padding: 0 0.682667rem;
  box-sizing: border-box;

  .label {
    flex-shrink: 0;
    width: 3.626667rem;

    font-size: 0.682667rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 0.938667rem;
  }
  .label + .desc {
    margin-left: 0.853333rem;
  }
  .desc {
    flex: 1;

    font-size: 0.682667rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #444444;
    line-height: 0.938667rem;
    word-break: break-all;
  }
}
.leaflet-item + .img-view {
  margin-top: 0.853333rem;
}
.img-view {
  padding: 0 0.682667rem;
  box-sizing: border-box;

  .leaflet-imgitem {
    width: 100%;
  }
}
.footer-box {
  text-align: center;
  width: 14.634667rem;
  height: 1.877333rem;
  background: #0089ff;
  border-radius: 0.938667rem;
  line-height: 1.877333rem;
  font-size: 0.682667rem;
  .btn {
    color: #fff;
  }
}
</style>
